import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../user/services/auth/auth.service';
import {CurrentUserService} from '../../../user/services/current-user/current-user.service';
import {environment} from '../../../../../environments/environment';


@Component({
  selector: 'app-protected-layout',
  templateUrl: './protected-layout.component.html',
  styleUrls: ['./protected-layout.component.scss']
})
export class ProtectedLayoutComponent implements OnInit {

  isCerf = environment.cerf;
  constructor(private auth: AuthService, private currentUserService: CurrentUserService) { }

  ngOnInit(): void {
    if (this.auth.isAuthenticated()) {
      this.currentUserService.getCurrentUser().subscribe();
    }
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/layout/components/protected-layout/protected-layout.component.ts